import { createFileRoute } from '@tanstack/react-router'

import {
  PlaygroundPage,
  type PlaygroundSearch,
} from '#/modules/agents/playground/playground-page'

const text = (value: unknown) =>
  typeof value === 'string' && value ? value : undefined

function Playground() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <PlaygroundPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  )
}

// The one page of the Agents section that is open: chat with any agent inside a
// chosen organization, as the signed-in admin, with every write held for approval.
export const Route = createFileRoute('/_shell/playground')({
  component: Playground,
  validateSearch: (raw: Record<string, unknown>): PlaygroundSearch => ({
    organizationId: text(raw.organizationId),
    agentId: text(raw.agentId),
    conversationId: text(raw.conversationId),
  }),
})
